import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';
import { candExamsDPRoot } from '@cm/feature/exam';

const dpRoot = `${candExamsDPRoot}|Review Candidate Exam`;

export type SPReviewCandidateExamLoc = 'SPReviewCandidateExamCheckboxLabel';

export const spReviewCandidateExamLocs: LocDefs<SPReviewCandidateExamLoc> = {
	SPReviewCandidateExamCheckboxLabel: {
		defaultValue: 'Notify candidate on review',
		description: 'Label for the option to send candidate an automated email.',
		displayPath: `${dpRoot}|Send Email`,
		displayType: 'Label',
		feature: HubFeature.Exam,
		portal: 'SP',
	},
};

export const LOC_KEYS = MapLocKeys<SPReviewCandidateExamLoc>(spReviewCandidateExamLocs);
export type SpReviewCandidateExamLocType = LocMap<SPReviewCandidateExamLoc>;
